<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">

		<el-tabs v-model="from.type" @tab-click="handleClick">
			<el-tab-pane label="題目數量" name="1">
			</el-tab-pane>
			
			<el-tab-pane label="做題時間" name="2">
			</el-tab-pane>
			
			<el-tab-pane label="通知時間" name="3">
			</el-tab-pane>
		</el-tabs>


		<div class="mb-2 mt-2 pt-3">
			<button-search :isphone="layout.is_phone" ref="buttonSearch" placeholder="搜索參數名稱" @search="searchEvent" :showGj="true">
				<!-- 左边 -->
				<template #left>
					<el-button class="mr-2" v-auth="'add'+auth_val" @click="openModel(false)" type="primary" size="mini">添加參數</el-button>
					<!-- <el-button type="danger" v-auth="'delAdmin'" @click="deleteAll" size="mini">批量删除</el-button> -->
				</template>
				
				<!-- 高級搜索 -->
				<template #from>
					<el-form inline ref="form" :model="from" label-width="100px">
						<el-form-item label="參數名稱" class="mb-0">
							<el-input size="small" v-model="from.name" placeholder="搜索參數名稱"></el-input>
						</el-form-item>
					
						<el-form-item label="啟用狀態" class="mb-0">
							<el-select v-model="from.status" size="small" placeholder="請選擇查看類型">
								<el-option label="全部" :value="-1"></el-option>
								<el-option label="啟用" :value="1"></el-option>
								<el-option label="禁用" :value="0"></el-option>
							</el-select>
						</el-form-item>
						
						<el-form-item label="創建時間"  size="small"  class="mb-0">
							 <el-date-picker
							      v-model="from.time"
							      type="daterange"
							      align="right"
							      unlink-panels
								  value-format="yyyy-MM-dd"
							      range-separator="至"
							      start-placeholder="開始日期"
							      end-placeholder="結束日期"
							      :picker-options="pickerOptions">
							    </el-date-picker>
						</el-form-item>
						
						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">搜尋 </el-button>
							<el-button size="small" @click="clearSearch">清空篩選條件</el-button>
						</el-form-item>
				
					</el-form>
				</template>
			</button-search>
		</div>

		<!-- 表格 -->
		<div class="mt-3 pt-2">
			<el-table :data="tableData" border style="width: 100%" @selection-change="handleSelectionChange">
				
				<el-table-column align="center" prop="sort" label="排序" width="50">
				</el-table-column>

				<el-table-column align="center" width="280" prop="name" label="參數名稱">
				</el-table-column>

				<el-table-column align="center" width="280" prop="num_str" label="數值">
				</el-table-column>
		
				<el-table-column align="center" prop="status" label="啟用狀態" >
					<template slot-scope="scope">
						<el-button
						:type="scope.row.status ? 'success' : 'danger'" 
						size="mini"
						
						@click="changeStatus(scope.row)"
						plain>{{scope.row.status ? '啟用' : '禁用'}}
						</el-button>
					</template>
				</el-table-column>
				
				<el-table-column align="center" width="280"   prop="create_time" label="創建時間">
				</el-table-column>

				<el-table-column prop="id" align="center" width="140" label="操作">
					<template slot-scope="scope">
						<el-button-group>
							<el-button size="mini" plain type="primary" v-auth="'edit'+auth_val" @click="openModel(scope)">操作</el-button>
							<el-button @click="deleteItem(scope.row)" v-auth="'del'+auth_val" size="mini" plain type="danger">刪除</el-button>
						</el-button-group>
					</template>
				</el-table-column>
			</el-table>
		</div>


		<div style="height: 60px;"></div>
		<el-footer class="d-flex border-top bg-white align-items-center px-0 position-fixed" style="bottom: 0;left: 200px;right: 0;z-index: 100;">
			<!-- 底部 -->

			<div style="flex: 1;" class="px-2">
				<el-pagination :current-page="page.current" :page-sizes="page.sizes" :page-size="page.size" @size-change="handleSizeChange"
				 @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
				</el-pagination>
			</div>
		</el-footer>

		<el-dialog :close-on-click-modal="false"  :title="editIndex > -1 ? '修改參數' : '添加參數'" :visible.sync="createModel" top="5vh" :width="layout.is_phone?'90%':'50%'">
			<!-- 表單内容 -->
			<el-form :rules="rules" ref="form" :model="form" :label-width="layout.is_phone?'80px':'100px'">
				
				<el-form-item label="類型名稱" >
					<el-input v-if="from.type == 1" value="題目數量" disabled clearable size="small" style="width: 85%;"></el-input>
					<el-input v-if="from.type == 2" value="做題時間" disabled clearable size="small" style="width: 85%;"></el-input>
					<el-input v-if="from.type == 3" value="通知時間" disabled clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
			
				<el-form-item label="參數名稱" prop="name">
					<el-input  v-model="form.name" placeholder="參數名稱"  clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
			
				<el-form-item :label="from.type == 1 ? '數值' : '數值 (秒)'" prop="num">
					<el-input  v-model="form.num" type="number"  clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
			
				<el-form-item label="排序" prop="sort">
					<el-input  v-model="form.sort" type="number" placeholder="排序（正序）"  clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
				<el-form-item label="啟用狀態">
					<el-radio-group v-model="form.status" size="small">
						<el-radio :label="1" border>啟用</el-radio>
						<el-radio :label="0" border>禁用</el-radio>
					</el-radio-group>
				</el-form-item>

			</el-form>


			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">取 消</el-button>
				<el-button type="primary" @click="submit">確 定</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	import { mapState } from 'vuex';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				createModel: false,
				editIndex: -1,
				//搜索數据
				from: {
					name: '',
					status:-1,
					type:'1',
					time:[],
				},
				model_title: 'Classify',
				auth_val: 'Classify',
				preUrl: "data/classifyList", //列表地址
				delAllUrl: "data/delClassifyAll", //批量删除地址
				delUrl: "data/delClassify", //删除單条地址
				addUrl: "data/addClassify", //添加/修改地址
				editStatusUrl:"data/editStatusClassify",//修改狀態地址

				tableData: [],
				form: {
					id:0,
					name: "",
					num:0,
					sort:0,
					status: 1,
				},
				rules: {
					name: [{
							required: true,
							message: "名稱不能為空",
							trigger: 'blur',
						},
					],
				},
				prop: 'sort',
				sort: 'ascending',
				rule_list: [],
				check_img_list:[]
			}
		},
		watch: {
			refreshTrigger(newVal) {
				console.log('刷新触发，當前值:', newVal);
				this.getList();    // 如果有其他需要刷新的方法
				this.layout.getPageNum();
			},
		},
		computed: {
			...mapState(['refreshTrigger']), // 监听 Vuex state
		},
	
		methods: {
			handleClick(tab, event) {
				this.from.type = tab.name;
				this.search = this.from
				this.getList()
			},

			//提交
			submit() {
				this.$refs.form.validate(res => {
					if (res) {
						this.form.id = this.editIndex
						this.form.type = this.from.type
						this.addOrEdit(this.form)
					}
				})
			},

			// 打开模态框
			openModel(e = false) {
				// 增加
				if (!e) {
					// 初始化表單
					this.form = {
						id:0,
						name: "",
						num:0,
						sort:0,
						status: 1,
					}
					this.editIndex = -1
				} else {
					// 修改
					this.form = {
						id:e.row.id,
						name: e.row.name,
						num:e.row.num,
						sort:e.row.sort,
						status: e.row.status,
					}
					this.editIndex = e.row.id
				}
				// 打开dialog
				this.createModel = true
			},
		
			getListResult(e) {
				this.tableData = e.list
				this.check_img_list = e.list.map(item=>{
					return item.head
				})
			},
			// 清空篩選條件
			clearSearch() {
				this.from = {
					name: '',
					status:-1,
					type:"1",
					time:[],
				}
				//this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
			
		}
	}
</script>

<style>
</style>
